import * as React from "react";
import { useMemo } from "react";
import useScopePermissions from "hooks/useScopePermissions";
import GLCheckbox from "./GLCheckbox";
function GLCheckboxWithScope({ entity, hideCheckbox = false, isSelected, onSelect }) {
  const { scopePermissions } = useScopePermissions(entity);
  const isMutable = useMemo(() => scopePermissions == null ? void 0 : scopePermissions.is_mutable, [scopePermissions]);
  if (hideCheckbox || !isMutable) return null;
  return /* @__PURE__ */ React.createElement(GLCheckbox, { checked: isSelected(entity), onChange: onSelect(entity), "data-testid": "rule-checkbox" });
}
export default GLCheckboxWithScope;
